import { Box, Grid, Typography } from "@mui/material";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";

// Footer Logo----------
import FooterLogo from "../../Images/Universal/PG Logo.svg";
import Play_Store from "../../Images/Universal/Play Store.webp"
import Email_Icon from "../../Images/Universal/email.svg"
import Phone_Icon from "../../Images/Universal/phone.svg"

const Footer = () => {

  const ImportantLinks = [
    {
      label: "About Us",
      link: "/about-us/"
    },
    {
      label: "Blogs",
      link: "/blogs"
    },
    {
      label: "Contact Us",
      link: "/contact-us"
    },
    {
      label: "Terms & Conditions",
      link: "/terms-conditions/"
    },
    {
      label: "Privacy Policy",
      link: "/privacy-policy/"
    },
    {
      label: "Support Center",
      link: "/support-center/"
    }
  ];

  const FollowUsLinks = [
    { label: "Facebook", link: "https://www.facebook.com/officialpredictionguruji/" },
    { label: "Whatsapp", link: "https://wa.me/+919876543210" },
    { label: "Telegram", link: "https://telegram.me/officialpredictionguruji" },
    { label: "Instagram", link: "https://www.instagram.com/officialpredictionguruji/" }
  ];

  return (
    <>
      <Box
        className="top-footer d-flex position-fixed w-100"
        style={{
          zIndex: 99,
        }}
      >
        <Container>
          <Grid container gap={5} className="justify-content-center">
            <Grid
              item
              lg={3.5}
              sm={6}
              xs={11}
              className="d-flex justify-between align-items-center bg-white px-1"
              style={{
                borderRadius: "50px",
                paddingTop: "4px",
                paddingBottom: "1px",
                maxWidth: "350px",
                boxShadow: "0px 0px 10px 5px #DC9A2B52",
                gap: "10px",
              }}
            >
              <button>
                <Link
                  to="/schedule"
                  className="bg-[#000] border-[#fff] hover:border-[#252927] px-3 py-2 text-white d-inline-block"
                  style={{
                    borderRadius: "20px",
                    borderWidth: "0 0 3px 0",
                    fontWeight: 600,
                    minWidth: "100px",
                  }}
                >
                  Schedule
                </Link>
              </button>
              <button>
                <Link
                  to="/series-list"
                  className="bg-[#000] border-[#fff] hover:border-[#252927] px-3 py-2 text-white d-inline-block"
                  style={{
                    borderRadius: "20px",
                    borderWidth: "0 0 3px 0",
                    fontWeight: 600,
                    minWidth: "100px",
                  }}
                >
                  Series
                </Link>
              </button>
              <button>
                <Link
                  to="/icc-rankings"
                  className="bg-[#000] border-[#fff] hover:border-[#252927] px-3 py-2 text-white d-inline-block"
                  style={{
                    borderRadius: "20px",
                    borderWidth: "0 0 3px 0",
                    fontWeight: 600,
                    minWidth: "100px",
                  }}
                >
                  Rankings
                </Link>
              </button>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* Main Footer--------- */}
      <Box component="footer" className="footer-wrapper pt-5 pb-4 bg-black">
        <Container>
          <Grid container className="zIndex-1 justify-between gap-lg-1 gap-4">
            <Grid item lg={4} xs={12} className="text-lg-start text-center pe-lg-5">
              <Box className="footer-logo-wrapper mx-lg-0 mx-auto mb-4">
                <Link to="https://predictionguruji.org/" className="">
                  <img src={FooterLogo} alt="footer logo" className="mx-lg-0 mx-auto" />
                </Link>
              </Box>
              <Typography
                variant="p"
                component="p"
                gutterBottom
                className="footer-menu mb-3 text-gray"
              >
                Prediction Guruji is not a bookmaker but an individual
                website offering research based reviews, news and information on
                top bookmakers. We, at Prediction Guruji, do not have
                ownership with any of the bookmakers listed by us. We only
                provide guide and information to Cricket betting sites and their
                services.
              </Typography>
            </Grid>
            <Grid item lg={3} sm={3.5} xs={12}>
              <Typography variant="h4" className="mb-3">
                <span className="">Important Links</span>
              </Typography>
              {ImportantLinks.map((val, ind) => {
                return (
                  <Typography
                    variant="subtitle1"
                    component="p"
                    gutterBottom
                    key={ind}
                    className="footer-menu mb-3"
                  >

                    <Link
                      to={`https://predictionguruji.org${val.link}`}
                      className="text-gray"
                    >
                      {val.label}
                    </Link>
                  </Typography>
                );
              })}
            </Grid>
            <Grid item lg={2.4} sm={2.5} xs={12}>
              <Typography variant="h4" className="mb-3">
                <span className="">Follow Us On</span>
              </Typography>
              {FollowUsLinks.map((val, ind) => {
                return (
                  <Typography
                    variant="subtitle1"
                    component="p"
                    gutterBottom
                    key={ind}
                    className="footer-menu mb-3"
                  >
                    <Link
                      to={`${val.link}`}
                      className="text-gray"
                    >
                      {val.label}
                    </Link>
                  </Typography>
                );
              })}
            </Grid>
            <Grid item lg={2.4} sm={4.5} xs={12}>
              <Typography variant="h4" className="mb-3">
                <span className="">Contact Us</span>
              </Typography>
              <Box className="icon-box-wrapper">
                <Link to="mailto:predictionguru@gmail.com"
                  className="text-gray" >
                  <Grid container className="gap-3 items-center">
                    <Grid item xs={2}>
                      <Box className="icon-box">
                        <img src={Email_Icon} alt="email" />
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography variant="h5" className="font-600 text-white">
                        <span className="">Email</span>
                      </Typography>
                      <Typography
                        variant="p"
                        component="p"
                        gutterBottom
                        className="footer-menu text-gray"
                      >
                        predictionguru@gmail.com
                      </Typography>
                    </Grid>
                  </Grid>
                </Link>
              </Box>
              <Box className="icon-box-wrapper mt-4">
                <Link to="tel:+919876543210"
                  className="text-gray" >
                  <Grid container className="gap-3 items-center">
                    <Grid item xs={2}>
                      <Box className="icon-box">
                        <img src={Phone_Icon} alt="email" />
                      </Box>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography variant="h5" className="font-600 text-white">
                        <span className="">Phone</span>
                      </Typography>
                      <Typography
                        variant="p"
                        component="p"
                        gutterBottom
                        className="footer-menu text-gray"
                      >
                        +91 9876543210
                      </Typography>
                    </Grid>
                  </Grid>
                </Link>
              </Box>

              <Link to={`https://play.google.com/store/apps/details?id=com.predictionguruji.io&pcampaignid=web_share`} target="_blank"
                className="text-white"
              >
                <img src={Play_Store} />
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* Bottom Footer---------- */}
      <Box component="footer" className="bottom-footer py-3">
        <Container className="py-1">
          <Grid container className="zIndex-1">
            <Grid item xs={12}>
              <Typography component="p" className="text-center">
                © 2026 Prediction Guruji. All rights reserved.{" "}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
